<div class="d-flex justify-content-start align-items-center pt-2 pb-2">
    <h6>
        Selezionare il nuovo conto corrente:
    </h6>
</div>
<app-basic-form [form]="form" [keys]="keys"></app-basic-form>
<div class="d-flex flex-column justify-content-start mt-4">
    <div class="card-disclaimer-label" *ngIf="showNoCCAvailableErrorMessage">Attenzione! Le uniche coordinate bancarie disponibili per la selezione coincidono con quelle correnti</div>
</div>
